<script setup>
import CtaIllustrationHowDoIAddGiftsLarge from "~/svg/cta-illustration-how-do-i-add-gifts-large.svg";
</script>

<template>
    <a
        href="https://support.gifthero.com/page/adding-gifts/"
        target="_blank"
        rel="noopener noreferrer"
        class="group flex flex-col items-center justify-center gap-3 rounded-[4px] bg-white p-6 text-center transition max-lg:flex-row max-lg:gap-6 max-lg:py-4"
    >
        <CtaIllustrationHowDoIAddGiftsLarge
            class="size-[110px] shrink-0 max-lg:size-[84px]"
            aria-hidden="true"
        />
        <span class="flex flex-col items-center gap-2 max-lg:items-start">
            <span
                class="font-brand-display text-[24px] font-black italic uppercase leading-[1.1] text-brand-navy"
            >
                How Do I<br />
                Add Gifts?
            </span>
            <span
                class="font-brand text-[13px] font-bold text-brand-red underline underline-offset-2 transition group-hover:text-brand-navy"
            >
                Learn More
            </span>
        </span>
    </a>
</template>
